<template>
  <div>
    <el-dialog :title="$t('message.manualOrderingOnTaobao')" :close-on-click-modal="false"
      :visible.sync="$parent.addGoodsDialogVisible" width="1142px" center>
      <div class="addGoods">

        <!-- 添加 -->
        <div class="add">
          <el-button size="mini" type="success" @click="add">{{
            $t("message.add")
          }}</el-button>
        </div>
        <div class="order">
          <span> 订单号： </span><el-input v-model="$parent.order" onfocus="this.select()"></el-input>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 商品链接 -->
            <li class="flex2">
              {{ $t("message.ProductLink") }}
            </li>
            <!-- 图片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 商品数量 -->
            <li>{{ $t("message.numberOfProducts") }}</li>

            <!-- 操作 -->
            <li>{{ $t("message.operation") }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 商品链接 -->
            <li class="flex2">
              <el-input v-model="item.url" @blur="goodsParticulars(item.url, index)" onfocus="this.select()"></el-input>
            </li>
            <!-- 图片 -->
            <li>
              <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <a href="javascript:;" @click="i = index">
                  <el-image :src="item.pic" style="width: 60px; height: 60px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" class="image-slot">
                    </div>
                  </el-image>
                </a>
              </el-upload>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template" @click="editAttribute(item, index)">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 商品数量 -->
            <li>
              <el-input v-model="item.quantity" onfocus="this.select()" type="number"></el-input>
            </li>

            <!-- 操作 -->
            <li>
              <!-- 删除 -->
              <el-button size="mini" class="dark" type="primary" @click="delItem(index)">
                {{ $t("message.delete") }}
              </el-button>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.addGoodsDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 修改属性 -->
    <attribute v-if="attributeDialogVisible" :detail="itemDetai" />
  </div>
</template>
<script>
import attribute from "@/views/orderDetail/components/attribute";
export default {
  props: {
    user_id: { type: String },
    isUser_id: { type: Boolean },
  },
  components: { attribute },
  data() {
    return {
      type: "",
      tableData: [
        {
          sku_id: "",
          spec_id: "",
          detail: [],
          detail_y: [],
          goods_id: "",
          mi_id: "",
          goods_title: "",
          quantity: "",
          price: "",
          pic: "",
          shop_id: "",
          shop_name: "",
          from_platform: "",
          y_remark: "",
          url: "",
          sorting: 1,
        },
      ],
      attributeDialogVisible: false,
      itemDetai: {},
      goodsInventory: [],
      i: 0,
    };
  },
  computed: {
    typeList() {
      return this.$store.state.typeList;
    },
  },
  methods: {
    goodsParticulars(url, i) {
      this.$api.goodsUrlToGoodsId({ goods_url: url }).then(res => {
        const miId = res.data.mi_id || ''
        let timestamp = Math.floor(new Date().valueOf() / 1000)
        let sign = 'wakanda forever!@9523`'
        let datas = {
          shop_type: res.data.from_platform,
          goods_id: res.data.goods_id,
          mi_id: miId,
          timestamp,
          sign: this.$md5(`${sign}${timestamp}${sign}`)
        };
        this.$api.orderApi.goodsParticulars(datas).then((res) => {
          let data = res.data;
          this.goodsInventory = res.data.goodsInfo.goodsInventory;
          this.i = i;
          this.tableData[i].goods_id = data.goodsId;
          this.tableData[i].mi_id = data.mi_id || data.miId || miId;
          this.tableData[i].goods_title = data.titleC;
          this.tableData[i].shop_id = data.shopId;
          this.tableData[i].shop_name = data.shopName;
          this.tableData[i].from_platform = data.fromPlatform;
          this.tableData[i].pic = data.images[0];
          this.tableData[i].show = true;
          this.tableData[i].detail_y = [];
          this.tableData[i].goodsInventory = data.goodsInfo.goodsInventory
          this.$forceUpdate();
          console.log(this.tableData[i]);
        });
      })

    },
    // 新增
    add() {
      this.tableData.push({
        sku_id: "",
        spec_id: "",
        detail: [],
        goods_id: "",
        mi_id: "",
        goods_title: "",
        quantity: "",
        price: "",
        pic: "",
        shop_id: "",
        shop_name: "",
        from_platform: "",
        y_remark: "",
        url: "",
        sorting: this.tableData.length + 1
      });
    },
    // 删除
    delItem(i) {
      this.tableData.splice(i, 1);
    },
    // 修改属性
    editAttribute(item, i) {
      this.i = i;
      this.goodsInventory = item.goodsInventory
      if (item.show) {
        this.itemDetai = JSON.parse(JSON.stringify(item));
        this.attributeDialogVisible = true;
      }
    },
    // 接收修改属性
    receiveAttributeEdit(data, pic) {
      this.tableData[this.i].detail_y = data;
      this.tableData[this.i].detail = data;
      if (pic) {
        this.tableData[this.i].pic = pic;
      }
      this.attributeDialogVisible = false;
      this.searchPricr(data);
    },
    // 查找价格
    searchPricr(data) {
      let str = "";
      data.forEach((item) => {
        str += item.value + "㊖㊎";
      });
      str = str.substr(0, str.length - 2);
      for (let i = 0; i < this.goodsInventory.length; i++) {
        if (this.goodsInventory[i].keyC == str) {

          this.tableData[this.i].price = this.goodsInventory[i].valueC[0].price;
          this.tableData[this.i].sku_id =
            this.goodsInventory[i].valueC[0].skuId;
          this.tableData[this.i].spec_id =
            this.goodsInventory[i].valueC[0].specId;
          this.tableData[this.i].quantity =
            this.goodsInventory[i].valueC[0].startQuantity;
          break;
        } else {
          this.tableData[this.i].price = "";
          this.tableData[this.i].sku_id = "";
          this.tableData[this.i].spec_id = "";
        }
      }
      this.$forceUpdate();
    },
    //保存
    save() {
      let datas = {
        order_sn: this.$parent.order,
        goodsList: [],
      };
      this.tableData.forEach(item => {
        datas.goodsList.push({
          offerId: item.goods_id,
          mi_id: item.mi_id || '',
          skuId: item.sku_id,
          quantity: item.quantity,
          shop_name: item.shop_name,
        })
      })
      console.log(datas);
      this.$api.orderApi
        .taobaoOrderCreateHuman(datas)
        .then((res) => {

          this.$parent.addGoodsDialogVisible = false;
          let copyUrl = ''
          res.data.successList.forEach(item => {
            copyUrl += item.purchase_no
          })

          let oInput = document.createElement("textarea"); //创建一个隐藏input（重要！）
          oInput.value = copyUrl; //赋值
          document.body.appendChild(oInput);
          oInput.select(); // 选择对象
          document.execCommand("Copy"); // 执行浏览器复制命令
          oInput.className = "oInput";
          oInput.style.display = "none";
          this.$message.success(res.data.errorList != false ? '部分下单失败，请前往跨境宝后台核对' : '下单成功:' + '交易号:' + copyUrl + '.已复制粘贴板');
        });
    },
    // 上传成功
    handleAvatarSuccess(res) {
      this.tableData[this.i].pic = res.data;
      this.loading = false;
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";

      this.loading = true;
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
        this.loading = false;
      }
      return isJPG || isPNG || isSVG;
    },
  },

};
</script>
<style lang='scss' scoped>
.addGoods {
  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .order {
    display: flex;
    line-height: 34px;
    margin-bottom: 20px;


    span {
      width: 80px;
    }

    /deep/.el-input__inner {
      width: 260px;
      margin-left: 20px;
    }
  }

  .add {
    margin-bottom: 15px;
    text-align: right;
  }

  .table {
    ol {
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;

      li {
        height: 40px;
        text-align: center;
      }
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    .flex2 {
      flex: 3;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.8;
    }

    .template {
      width: 100%;
      padding: 10px;
      background-color: #fff;
      height: 80px;
      overflow: hidden;
      cursor: pointer;
    }
  }
}

/deep/.el-textarea__inner {
  padding: 5px;
  min-height: 63px !important;
  height: 100px !important;
}
</style>
